/**
 * The fallback photo pool (D3): four candid photographs from the brand pack,
 * for any card whose item has no cover of its own. A real `coverUrl` always
 * wins; these only fill the gap, so a member never sees a blank or a
 * placeholder drawing where the guide shows a person.
 *
 * ── Why URLs, and why these URLs ──────────────────────────────────────────
 * `@lb/ui` compiles with `tsc` and cannot import an image, and the pool is
 * ~280 KB — too much to inline as data URIs into every bundle that imports
 * the barrel. So the design system names the files and the app serves them:
 * `apps/web/public/brand/photos/` holds the optimised JPEGs, Vite copies
 * `public/` verbatim, and the prerender step serves the same `dist`. A test
 * in the app (`brand-photos.test.ts`) asserts every path here exists there,
 * so the two cannot drift apart silently. An app hosted under a different
 * base passes its own list through `PhotoCover`'s `fallbackSrcs`.
 */
export const FALLBACK_PHOTOS = [
    '/brand/photos/family-living-room.jpg',
    '/brand/photos/father-son-highfive.jpg',
    '/brand/photos/mother-child-sunset.jpg',
    '/brand/photos/mother-kids-drawing.jpg',
];
//# sourceMappingURL=fallback-photos.js.map